import { render, staticRenderFns } from "./StackCarousel.vue?vue&type=template&id=495a7fd2&scoped=true"
import script from "./StackCarousel.vue?vue&type=script&lang=js"
export * from "./StackCarousel.vue?vue&type=script&lang=js"
import style0 from "./StackCarousel.vue?vue&type=style&index=0&id=495a7fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a7fd2",
  null
  
)

export default component.exports